import { useState, useEffect } from 'react';
import { Row, Col, NavItem } from 'reactstrap';
import TableActions from 'components/layouts/table';
import Overview from './overview';
import { Link } from 'react-router-dom';
import useRouter from 'use-react-router';
import { Tabs } from 'components/general/Tabs';
import paths from 'routing/routes/_paths';
import Logs from './logs';
import Crons from './crons';

const tabs = [
  { name: 'logs', component: Logs },
  { name: 'crons', component: Crons }
];

const TopTabs = ({ activeTab }) => {
  return (
    <Tabs pills>
      {tabs.map(tab => (
        <NavItem key={tab.name} active={tab.name === activeTab}>
          <Link className="nav-link" to={`${paths.integrations}/${tab.name}`}>
            {tab.name}
          </Link>
        </NavItem>
      ))}
    </Tabs>
  );
};

const Integrations = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].name);
  const { match } = useRouter();

  useEffect(() => {
    if (match.params.tab) {
      setActiveTab(match.params.tab);
    }
  }, [match]);

  const ActiveComponent = tabs.find(tab => tab.name === activeTab).component;

  return (
    <Row>
      <Col xs={12} className="mb-4">
        <TableActions title="Integrations" actions={[{ type: 'search' }]} />
      </Col>
      <Col xs={12} className="mb-6">
        <Overview />
      </Col>
      <Col>
        <ActiveComponent topTabs={<TopTabs activeTab={activeTab} />} />
      </Col>
    </Row>
  );
};

export default Integrations;
